import React, { Component } from 'react';
import './App.css';
import { BrowserRouter as Router} from 'react-router-dom';
import BaseRouter from './routes';
import { connect } from 'react-redux';
import {  Button, Switch } from 'antd';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import 'antd/dist/antd.css'
import CustomLayout from './containers/Layout';
import * as actions from './store/actions/auth';
import ScrollToTop from './components/ScrollToTop';
import UnityContainer from './containers/UnityContainer';
import {getUserToken,getCookie,setCookie,getUserID,isOnStandalone} from './store/utility'
import NewWindow from 'react-new-window';
import Lineage from './components/Lineage';
import TutorialFilter from './containers/Tutorial'
import axios from 'axios';
import { unregister } from './serviceWorker';

import {
  BrowserView,
  MobileView,
  isMobile,
  isIOS,
  isEdge,
  isAndroid,
  isFirefox,
  isTablet,
  isChrome,
  isOpera,
} from "react-device-detect";
import RedirectionSystem from "./RedirectionSystem";

unregister();


class App extends Component{
  constructor(props){
    super(props);

    this.receiveUnityProps = this.receiveUnityProps.bind(this);
    this.receiveUnityPropsMaximized = this.receiveUnityPropsMaximized.bind(this);
    this.cancelUnityProps  = this.cancelUnityProps.bind(this);
    this.changeUnityShowState = this.changeUnityShowState.bind(this);
    this.unityLoaded = this.unityLoaded.bind(this);
    this.askResetUnity = this.askResetUnity.bind(this);
    this.resetUnityResetState = this.resetUnityResetState.bind(this);
    this.datasetButtonClicked = this.datasetButtonClicked.bind(this);
    this.windowedUnity = this.windowedUnity.bind(this);
    this.sendProps = this.sendProps.bind(this);
    this.clearCache = this.clearCache.bind(this);
    this.openUnityFromOtherComponents = this.openUnityFromOtherComponents.bind(this);
    this.changeLineageStatus = this.changeLineageStatus.bind(this);
    this.showCellInUnity = this.showCellInUnity.bind(this);
    this.clearAllLineage = this.clearAllLineage.bind(this);
    this.hideLineage = this.hideLineage.bind(this);
    this.showLineage = this.showLineage.bind(this);
    this.hideCellsAllTimes = this.hideCellsAllTimes.bind(this);
    this.colorize = this.colorize.bind(this);
    this.applySelection = this.applySelection.bind(this);
    this.hideCells = this.hideCells.bind(this);
    this.resetSelectionOnSelectedCells = this.resetSelectionOnSelectedCells.bind(this);
    this.propagateThis = this.propagateThis.bind(this);
    window.onpopstate = function(event) {
      if (this.state.unity_active){
        this.setState({windowed:true})
      }
    }.bind(this);

    window.addEventListener('load', this.handleLoad);
    window.addEventListener('beforeunload',this.handleUnload);
}

/*static propTypes = {
  location: React.PropTypes.object.isRequired
}*/

  state ={
    send_background_color_update : undefined,
    pickCellsParams : undefined,
    pickCellsParams_update : undefined,
    receiveColorInfo : null,
    tutorial_displayed : false,
    tutorial_list : [],
    id_dataset : -1,
    lineage_time : -1,
    lineage_id : -1,
    display_lineage : false,
    unity_active : false,
    unity_props : {},
    clearLineage: false,
    unity_loaded : false,
    unity_reset : false,
    windowed : false,
    dataset_button_clicked : false,
    clearCache : false,
    showFromMainMenu:false,
    hide_lineage_t : -1,
    hide_lineage_id : -1,
    show_lineage_t : -1,
    show_lineage_id : -1,
    propagatethis_listcells_update : undefined,
    session_stages : [],
    hide_all_t_v : -1,
    hide_all_t_listcells : -1,
    colorize_t:-1,
    colorize_id:-1,
    colorize_rgb:-1,
    uncolorize_t : -1,
    uncolorize_id : -1,
    apply_select_rgb:-1,
    apply_select_listcells:-1,
    apply_selectmap_listcells:-1,
    resetselection_listcells:-1,
    hidecells_params:undefined,
    hidecells_params_update:undefined,
    propagatethis_v:-1,
    propagatethis_listcells:undefined,
    propagatethis_rgb:-1,
    token : "",
    user_settings : [],
    tuto_settings_list : [],
    user_settings_got : false,
    hide_tutorials_session : false,
    oldLocation : "",
    updated_dataset : false,
    window_location : "",
    liveModeProps : {},
    dropped_files : undefined,
    clear_tutorials : false,
    live_mode : false,
    unity_loading_progress : -1,
    uncolorize_listcells : undefined,
    uncolorize_lineage : false,

    colorize_listcells : undefined,

    reset_selection_lineage : false,
    apply_selection_lineage : false,
    colorize_lineage : false,
    morphoPlotLineage : null,
    morphoPlotMaxTime : -1,
    morphoPlotMinTime : -1,
    send_background_color : undefined,
    //Maintenantce display
    maintenance : false,

    focus_canvas : "",
    //RGPD 
    panel_display:"mandatory",
    close_display : false,
    allow_optionals : true,
    last_info_received : undefined,
    deployInfoID : undefined,
    last_info_update : false,

    reset_lineage_flag : false,
    
    alert_displayed : false,
    id_info_lineage : -1,
    multipleselectioncells : "",
    multipleselectioncells_reset : false,

    refresh_dataset : false,
    reset_lineage : false,
    lineage_close : false,
    lineage_selection_reset : false,
    searched_text : "",
    last_search_used : "",
    ask_clear : false,

    clearCellsParams : undefined,
    clearCellsParams_update : undefined,

    send_color_list : undefined,
    send_color_update : undefined,
    show_cell_list : undefined,
    show_cell_list_update : undefined,
    hide_cell_list : undefined,
    hide_cell_list_update : undefined,
    changeColorSelection : undefined,
    changeColorSelection_update : undefined,

    cancelCellsParams : undefined,
    cancelCellsParams_update : undefined,
  }
  updateLastSearched = (search) => {
    this.setState({last_search_used:search});
  }

  cancelCells = (parames) => {
    this.setState({cancelCellsParams:parames});
    this.setState({cancelCellsParams_update:this.state.cancelCellsParams_update === undefined?true:!this.state.cancelCellsParams_update});
  }

  updateSelectionColor = (params) => {
    this.setState({changeColorSelection:params});
    this.setState({changeColorSelection_update:this.state.changeColorSelection_update === undefined?true:!this.state.changeColorSelection_update});
  }
  updateClearAsk = () => {
    //console.log("Asked to clear app");
    //this.setState({ask_clear:!this.state.ask_clear});
  }

  refreshDataset = () => {
    this.setState({refresh_dataset:!this.state.refresh_dataset});
  }
  receiveMorphoMaxTime = (time) => {
    this.setState({morphoPlotMaxTime:time});
  }

  receiveMorphoMinTime = (time) => {
    this.setState({morphoPlotMinTime:time});
  }

  receiveColorInfo = (iddata) => {
    this.setState({receiveColorInfo:iddata});
  }

  changeSearchedText = (value) => {
    //this.setState({last_search_used:"search"});
    this.setState({searched_text : value === undefined?"":value});
  }

  handleLoad = () => {
    const user_id = getUserID() !== undefined ? getUserID() : 0;
    let tab_numb = localStorage.getItem('tabs') !== undefined ? JSON.parse(localStorage.getItem('tabs')) : 0;
    tab_numb++;
    if (tab_numb === 1)
    {axios.get('/api/storelogin/', {params : {user_id:user_id?user_id:0}}).then(() => {}).catch(() => {});}
    try {
      localStorage.setItem('tabs',JSON.stringify(tab_numb));
    }
    catch(e){
      if (e.name === "NS_ERROR_FILE_CORRUPTED"){
          window.alert("Your browser's cache seems to be corrupted, try clearing the browser cache and try again");
      }
  }
  }

  storeMorphoPlotLineage = (lineage) => {
    this.setState({morphoPlotLineage:lineage});
  }

  clearMorphoPlotLineage = () => {
    //console.log("CLEAR PLot lineage");
    this.setState({morphoPlotLineage:undefined});
  }

  handleUnload = () => {
    const user_id = getUserID() !== undefined ? getUserID() : 0;
    let tab_numb = localStorage.getItem('tabs') !== undefined ? JSON.parse(localStorage.getItem('tabs')) : 1;
    tab_numb--;
    if (tab_numb === 0)
    {axios.get('/api/storelogout/', {params : {user_id:user_id?user_id:0}}).then(() => {}).catch(() => {});}
    try {
      localStorage.setItem('tabs',JSON.stringify(tab_numb));
    }
    catch(e){
      if (e.name === "NS_ERROR_FILE_CORRUPTED"){
          window.alert("Your browser's cache seems to be corrupted, try clearing the browser cache and try again");
      }
  }
  }

  sendToServer(payload, success, error) {
    //console.log(payload);
    const formData = new FormData();
    if (payload.attachments[0].image_url !== undefined)
      formData.append('file_url', payload.attachments[0].image_url);
    formData.append('author', payload.attachments[0].author_name);
    formData.append('text', payload.attachments[0].text);
    formData.append('title', payload.attachments[0].title);
    return axios.post(`/api/posttoslack/`,formData)
    
    /*return axios.get(`/api/people/${JSON.parse(u_id)}/`,{ headers: { Authorization: `Token ${this.state.token}` } })
    .then(res => {
        this.setState({user:res.data});
    });       */
  }
   
  onProgressUnity = (progress) => {
    this.setState({unity_loading_progress:progress});
  }

  clearCells = (newclearcells)=>
  {
    this.state.clearCellsParams=newclearcells;
    this.setState({clearCellsParams_update:this.state.clearCellsParams_update === undefined?true:!this.state.clearCellsParams_update});
  }

  uploadImage(image, success, error) 
  {
    const formData = new FormData();
    formData.append('image', image);
    return axios.post(`/api/feedbackimages/`,formData)
   
    /*return fetch('/api/feedbackimages/', { method: 'POST', data: formData })
      .then(({ url }) => success(url))
      .catch(err => error(err))*/
  }

  resetLineage = () =>
  {
    if (this.state.display_lineage === true)
    {
      this.setState({reset_lineage:!this.state.reset_lineage});
      this.setState({display_lineage:false});
      this.setState({display_lineage:true});
    }
  }
  propagateThis(vrgblistcells){
  //  console.log("propagate");
    this.state.propagatethis_listcells=vrgblistcells;
    this.setState({propagatethis_listcells_update:this.state.propagatethis_listcells_update === undefined?true:!this.state.propagatethis_listcells_update});
  //  this.setState({propagatethis_v:v});
   // this.setState({propagatethis_rgb:r+":"+g+":"+b});
  }

  multipleSelection = (listcellcolors) => {
    const reset = !this.state.multipleselectioncells_reset;
    this.setState({multipleselectioncells_reset:reset});
    this.setState({multipleselectioncells:reset+"/"+listcellcolors});
  }

  hideCells(params){
  //  console.log("App hide Cells");
 //   console.log(params);
  //  console.log("old app hide cells");
  //  console.log(this.state.hidecells_params);
    this.state.hidecells_params = params;
    //this.setState({hidecells_params:params});
    this.setState({hidecells_params_update:this.state.hidecells_params_update === undefined?true:!this.state.hidecells_params_update});
  }

  resetSelectionOnSelectedCells(listcells){
  // console.log("reset selection");
   // console.log(listcells);
    const reset = !this.state.reset_selection_lineage;
    this.setState({reset_selection_lineage:reset});
   // console.log(reset+"/"+listcells);
    this.setState({resetselection_listcells:reset+"/"+listcells});
  }


  colorizeMultipleCells = (listcells) => {
    // console.log("reset selection");
     // console.log(listcells);
    const reset = !this.state.colorize_lineage;
    this.setState({colorize_lineage:reset});
      //console.log(reset+"/"+listcells);
      this.setState({colorize_listcells:reset+"/"+listcells});
    }

    updateInfoDeployed = (info_id) => {
      const reset = !this.state.last_info_update;
      this.setState({last_info_update:reset});
      this.setState({deployInfoID:info_id+"/"+reset});
    }

        receiveMessage = (event) => {
           if (event.data !== "" && this.state.done === true && this.state.api_mode)
             this.API_Load(event.data);
         }

          //use the url data to start Unity
       API_Load = (param) => {
         let sent = "?";
         for (let parameter in param){
             sent = sent + parameter+"="+param[parameter]+"&"
        }
       sent = sent.substring(0, sent.length - 1);
         const pairs = sent.substring(sent.indexOf('?') + 1).split('&');
         for (let i = 0; i < pairs.length; i++){
        const pair = pairs[i].split('=');
        if (pair[0] === "stage")sent=sent+"&time="+this.getTimeFromStage(pair[1]);
      }
      this.unityContent.send("SetsManager","API_Load",sent);
    }

  uncolorizeMultipleCells = (listcells) => {
    // console.log("reset selection");
     // console.log(listcells);
    const reset = !this.state.uncolorize_lineage;
    this.setState({uncolorize_lineage:reset});
      //console.log(reset+"/"+listcells);
      this.setState({uncolorize_listcells:reset+"/"+listcells});
    }

  applySelection(rgblistcells){
  //  console.log("applyselection");
    this.setState({apply_select_listcells:rgblistcells});
    //this.setState({apply_select_rgb:r+":"+g+":"+b});
  }
  applySelectionMap = (rgblistcells) => {
    //  console.log("applyselection");
      this.setState({apply_selectmap_listcells:rgblistcells});
      //this.setState({apply_select_rgb:r+":"+g+":"+b});
    }

  uncolorize = (tid) => {
  //  console.log("uncolorize");
    this.setState({uncolorize_id:tid});
    //this.setState({uncolorize_t:t});
  }

  colorize(tidrgb){
 //   console.log(tidrgb);
    const reset = !this.state.colorize_lineage;
    this.setState({colorize_lineage:reset});
    this.setState({colorize_rgb:tidrgb+"/"+reset});
    //this.setState({colorize_rgb:r+":"+g+":"+b});
    //this.setState({colorize_t:t});
   // this.setState({colorize_id:id});
    
  }

  receiveInfo = (infojson) => {
    this.setState({last_info_received:infojson});
  }
  hideLineage(tid){
    this.setState({hide_lineage_id:tid});
   // this.setState({hide_lineage_t:t});
  }

  askCloseLineage = () => {
    this.setState({lineage_close:!this.state.lineage_close});
  }
  hideCellsAllTimes(listcells){
    this.setState({hide_all_t_listcells:listcells});
   // this.setState({hide_all_t_v:v});
  }
  showLineage(tid){
    this.setState({show_lineage_id:tid});
   // this.setState({show_lineage_t:t});
  }

  SendColors = (listcellscolor) => {
    if (listcellscolor !== this.state.send_color_list){
      this.setState({send_color_list:listcellscolor});
      if (this.state.send_color_update === undefined){
        this.setState({send_color_update : false});
      }
      else {
      this.setState({send_color_update:!this.state.send_color_update});
      }
    }
  }

  SendShowCells = (celllist) => {

    this.state.show_cell_list=celllist;
    this.setState({show_cell_list_update:this.state.show_cell_list_update===undefined?true:!this.state.show_cell_list_update});

  }

  SendHideCells = (celllist) => {
    if (celllist !== this.state.hide_cell_list){
    this.setState({hide_cell_list:celllist});
    if (this.state.hide_cell_list_update === undefined){
      this.setState({hide_cell_list_update : false});
    }
    else {
    this.setState({hide_cell_list_update:!this.state.hide_cell_list_update});
    }
    }
  }


  clearAllLineage() {
    this.setState({clearLineage:!this.state.clearLineage});
  }

  showCellInUnity(t,id){
    this.state.lineage_selection_reset = !this.state.lineage_selection_reset; 
    this.setState({lineage_time:t});
    this.setState({lineage_id:id})
  }

  receiveUnityProps(unityparams){
   // if (this.state.refresh_unity_params === undefined)this.setState({refresh_unity_params:false});
    setTimeout(function() {
      this.sendProps(unityparams);
      this.setState({unity_props:unityparams});
    }.bind(this), 300);
    this.setState({windowed:false});
    this.setState({live_mode:false});
    //How to handle API Load ??? 
    if (this.state.unity_loaded || isOnStandalone() || this.getUserSettingsValue("standalone_start") === "true"){
      this.setState({updated_dataset:true});
      this.askResetUnity();
      this.setState({display_lineage:false});
      this.setState({unity_active:false});
      this.setState({windowed:false});
    }

   // this.setState({unity_props:unityparams});
  }

  hasValidatedCookies = () => {
    var ck = getCookie('rgpd_accept')
    //console.log(ck);
    return ck !== undefined && ck !== null;
  }
  receiveUnityPropsLiveMode(){
    this.setState({windowed:false});
    this.setState({live_mode:true});
    //How to handle API Load ??? 
    if (this.state.unity_active || isOnStandalone() || this.getUserSettingsValue("standalone_start") === "true"){
      this.setState({updated_dataset:true});
      this.setState({display_lineage:false});
      this.askResetUnity();
      this.setState({unity_active:false});
      this.setState({windowed:false});
    }
    setTimeout(function() {
      this.sendProps(this.state.liveModeProps);
      //this.setState({unity_props:this.state.liveModeProps});
    }.bind(this), 300);
   // this.setState({unity_props:unityparams});
  }

  receiveUnityPropsMaximized(unityparams){
    this.setState({windowed:false});
    this.setState({live_mode:false});
    //How to handle API Load ??? 
    if (this.state.unity_loaded || isOnStandalone() || this.getUserSettingsValue("standalone_start") === "true"){
      this.setState({display_lineage:false});
      this.askResetUnity();
      this.setState({unity_active:false});
      this.setState({windowed:false});
    }
    setTimeout(function() {
      this.sendPropsMax(unityparams);
      this.setState({unity_props:unityparams});
    }.bind(this), 500);
   // this.setState({unity_props:unityparams});
  }

  receiveStage = (stage) => {
    this.setState({session_stages:stage});
  }

  sendProps(unityparams){
    this.setState({unity_props:unityparams});
    this.setState({windowed:false});
    if ( this.getUserSettingsValue("standalone_start") !== "true") {
      this.setState({unity_active:true});
    }
  }

  sendPropsMax(unityparams){
    this.setState({unity_props:unityparams});
    this.setState({windowed:false});

    if ( this.getUserSettingsValue("standalone_start") !== "true") {
      this.setState({unity_active:true});
    }
  } 
  changeLineageStatus(id_set,id_info,display_lineage){
    this.setState({id_dataset:id_set});
    this.setState({id_info_lineage:id_info});
    this.setState({display_lineage:display_lineage});
  }
  openUnityFromOtherComponents(){
    this.setState({showFromMainMenu:!this.state.showFromMainMenu});
    this.changeUnityShowState(!this.state.unity_active);
    this.setState({windowed:false});
  }

  datasetButtonClicked(){
    this.setState({dataset_button_clicked:!this.state.dataset_button_clicked});
  }

  unityLoaded(state){
    this.setState({unity_loaded:state});
  }

  changeUnityShowState(nextState){
    this.setState({unity_active:nextState});
  }

  cancelUnityProps(){
    this.setState({unity_props:{}});
    this.setState({unity_active:false});
  }

  askResetUnity(){
    this.setState({unity_reset:!this.state.unity_reset});
  }

  clearCache(){
    this.setState({clearCache:!this.state.clearCache});
  }

  resetUnityResetState(){
    this.setState({unity_active:false});
    this.setState({unity_reset:false});
    this.setState({unity_props:undefined});
  }

  windowedUnity(state){
    this.setState({windowed:!this.state.windowed});
  }

  getUserSettingsValue(p_setting)
  {
    let value = -1;
    if (this.state.user_settings !== undefined){
        this.state.user_settings.map(sett => {
        if (sett.setting === p_setting){
          value = sett.value;
        }
      });
    }
    //console.log(value);
    return value;
  }

  ForceKeyboardState = (state) =>{
    this.setState({keyboard_state:state});
  }

  FocusCanvas = (f_mode) => {
  //  console.log("send focus : "+f_mode);
    this.setState({focus_canvas:f_mode});
  }

componentDidMount() {
  //window.__REACT_DEVTOOLS_GLOBAL_HOOK__.inject = function () {}
 // this.props.onTryAutoSignup();
 if ((isIOS || isAndroid || isMobile)){
  window.alert("MorphoNet has been created to work on a desktop browser, not using a mobile device. You may encounter problems rendering the website and the 3D viewer will not work.")
}
 else if (!isFirefox && !isChrome && !isEdge && !isOpera && (window.location.href.includes(".org/dataset")))
 {
    window.alert("The MorphoNet visualization system has been designed and developed to work on Firefox and Chrome browsers only. To be able to visualize the data, please use thoses browers. You can still explore the website using your current browser.");
 }


  window.addEventListener("dragover",function(e){
    e.stopPropagation();
    e.preventDefault();
    e.dataTransfer.dropEffect = 'copy';
  }.bind(this),false);

  document.addEventListener('click', function(e) {
 /*   console.log(e.target.id);
    if (e.target.id === "#canvas") {
        // Clicked on canvas
        this.FocusCanvas("1");
    } else {
        // Clicked outside of canvas
        this.FocusCanvas("0");
    }*/
}.bind(this));

  window.addEventListener("drop",function(e){
    e.stopPropagation();
    e.preventDefault();
    if (e.dataTransfer !== null && e.dataTransfer.files.length > 0 && (e.dataTransfer.files[0].name.endsWith(".obj") || e.dataTransfer.files[0].name.endsWith(".stl")) && e.dataTransfer.files[0].size > 0){
      this.state.liveModeProps.name=e.dataTransfer.files[0].name;
      if (e.dataTransfer.files[0].name.endsWith(".obj")){
      let reader = new FileReader();
      const file = e.dataTransfer.files[0];
      reader.readAsText(file);
      reader.onload = function(e) {
        let start_index = 0;
        this.state.liveModeProps.obj = {};
        this.state.liveModeProps.stl = null;
        let index = 0;
        while (start_index < reader.result.length){
          this.state.liveModeProps.obj[index] = reader.result.substr(start_index,2000);
          start_index += 2000;
          index ++;
        }
        //console.log(reader.result.length);
        //this.state.liveModeProps.obj= reader.result;
        //console.log(this.state.liveModeProps.obj);
        this.receiveUnityPropsLiveMode();
      }.bind(this);
    }else {
      let reader = new FileReader();
      const file = e.dataTransfer.files[0];
      reader.readAsArrayBuffer(file);
      reader.onload = function(e) {
      //  console.log("onload");
      //  console.log(reader.result);
        this.state.liveModeProps.obj = null;
        const data = reader.result;
        const array = new Int8Array(data);
        this.state.liveModeProps.stl = array;
        this.receiveUnityPropsLiveMode();
      }.bind(this);
    }
    }
  }.bind(this),false);
  

  this.state.token = getUserToken();
  this.state.connected_user_id = getUserID();
  if (this.state.connected_user_id !== null){
    this.state.liveModeProps.id_user = this.state.connected_user_id;
  }
  if (this.state.token !== "" && this.state.token !== null){
    axios.get(`/api/settings/`,{ headers: { Authorization: `Token ${this.state.token}` } })
    .then(res => {
        this.setState({
            user_settings: res.data,
        });
        this.setState({user_settings_got : true});
        //console.log(this.state.user_settings);
    }).catch(() => {this.setState({user_settings_got : true});});
}else {
  this.setState({user_settings_got : true});
}
this.state.window_location = {...window.location};

/*document.addEventListener("drop", function(event) {
  //sevent.preventDefault();
  event.stopPropagation();
  console.log(event);
  return false;
  if ( event.target.className === "droptarget" ) {
    document.getElementById("demo").style.color = "";
    event.target.style.border = "";
    var data = event.dataTransfer.getData("Text");
    event.target.appendChild(document.getElementById(data));
  }
}.bind(this));*/

setInterval(() => { 
  if (window.location.href !== this.state.window_location.href){
  this.state.window_location = {...window.location};
  this.state.tutorial_list = this.state.tutorial_list.filter(tuto => tuto.setting.includes("layout"));
  this.setState({clear_tutorials:!this.state.clear_tutorials});
  //clear tutorials
} }, 1000);
}

removeScroll = (e) => {
  if (!this.state.windowed){
    //e.preventDefault();
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }
}

componentDidUpdate(prevProps,prevState){

    if (prevState.token !== getUserToken() && prevState.token !== null){
       this.componentDidMount();
    }
/*
  if (this.state.unity_loaded !== prevState.unity_loaded && this.state.unity_loaded === true){
    //console.log("unity is loaded");
    if (localStorage.getItem('unityProps') !== undefined){
      //console.log("unity props found");
      this.receiveUnityProps(JSON.parse(decryptString(localStorage.getItem('unityProps'))));
      localStorage.removeItem('unityProps');
    }
  }*/

  if (this.props.location !== undefined && this.props.location.pathname !== prevProps.location.pathname){
    //console.log("Location changed");
    this.hideTutorialsForSession();
  }

  if (this.state.unity_active !== prevState.unity_active){
    if (this.state.unity_active && !isOnStandalone()){
      window.addEventListener("scroll", this.removeScroll);
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto'
      });
    }
    else {
      window.removeEventListener("scroll", this.removeScroll);
    }
  }
}

pickCells = (celllist) => {
  this.state.pickCellsParams=celllist;
  this.setState({pickCellsParams_update:this.state.pickCellsParams_update===undefined?true:!this.state.pickCellsParams_update});
}

sendTracking = (id_dataset,feature_list) => {
  //console.log("Tracking : "+feature_list);
  if (getCookie('rpgd_track') === undefined || getCookie('rpgd_track') === "true") {
    if (id_dataset === -1){
      axios({
        method: 'post',
        url: '/api/storeuserinteraction/',
        data: {
          user_id : this.state.connected_user_id,
          feature_list : feature_list,
        }
      });
    }
    else {
      axios({
        method: 'post',
        url: '/api/storeuserinteraction/',
        data: {
          user_id : this.state.connected_user_id,
          id_dataset:id_dataset,
          feature_list : feature_list,
        }
      });
    }
  }
    }
    sendTrackingSimulation = (name_simulation, feature_list) => {
        //console.log("Tracking : "+feature_list);
        if (getCookie('rpgd_track') === undefined || getCookie('rpgd_track') === "true") {
            if (name_simulation === "") {
                axios({
                    method: 'post',
                    url: '/api/storeuserinteraction/',
                    data: {
                        user_id: this.state.connected_user_id,
                        feature_list: feature_list,
                    }
                });
            }
                        else {
                            axios({
                    method: 'post',
                    url: '/api/storeuserinteraction/',
                    data: {
                        user_id: this.state.connected_user_id,
                        //name_simulation: name_simulation,
                        feature_list: feature_list,
                    }
                });
            }
        }
    }

handleClickLayout = (e) => {
  //console.log(e);
}

hideTutorialsForSession = () => {
  this.setState({hide_tutorials_session:true});
}



closeTutorialFunc = () => {
  const nextFavorites = [...this.state.tutorial_list];
  nextFavorites.shift();
  this.setState({ tutorial_list: nextFavorites });
  //console.log(this.state.tutorial_list);
  if (nextFavorites === 0){
    this.setState({tutorial_displayed : false});
  }
  else {
    if (nextFavorites[0] !== undefined && (nextFavorites[0].text === undefined || nextFavorites[0].text === "")){
      this.state.tutorial_list = [];
      this.setState({tutorial_displayed:false});
    }
  }
  window.scrollTo(window.scrollX+1,window.scrollY+1);window.scrollTo(window.scrollX-1,window.scrollY-1);
}

DisplayTutorialFunc = (node,posx,posy,text,source_page,is_div) => {
  /*var last_setting = undefined;
  var copy =[];
  var filtered_copy = [];
  if (this.state.tutorial_list !== undefined && this.state.tutorial_list.length > 0)
  { copy = {...this.state.tutorial_list};
    for (var elem in copy){
      if (!copy[elem].setting.includes('layout')){
        filtered_copy.push(copy[elem]);
      }
    }

  if (filtered_copy.length>0)
    last_setting =filtered_copy[filtered_copy.length -1];
  }
  if (this.getUserSettingsValue("tutorial") !== "false" && !this.state.hide_tutorials_session && getCookie('hide_tutorials') !== "true"){
  if (filtered_copy.length > 0 && filtered_copy[filtered_copy.length -1] !== undefined && source_page !== filtered_copy[filtered_copy.length -1].setting && !source_page.includes('layout')){
    this.state.tuto_settings_list.push(this.state.tutorial_list[this.state.tutorial_list.length -1].setting);
    this.state.tutorial_list = this.state.tutorial_list.filter(tuto => tuto.setting.includes("layout"));
  }
  //text = text.replace('\n','<br />');
  if (((last_setting === undefined || source_page === last_setting) || source_page.includes('layout') !== undefined || this.state.tuto_settings_list.length === 0 || this.state.token === undefined || this.state.token === "") && !window.location.href.includes('morphoapi') && !window.location.href.includes('morphoplot'))
  {
    //console.log({'text':text,'x':posx,'y':posy,'right':posright,'setting':setting,'arrow':arrow});
    this.setState({tutorial_displayed:true});
    this.state.tutorial_list.push({'text':text,'x':posx,'y':posy,'node':node,'setting':source_page,'is_div':is_div});
  }
  }*/
}

FlushTutorialList = () => {
  this.state.tutorial_list = [];
  //this.state.tutorial_list = this.state.tutorial_list.filter(tuto => tuto.setting.includes("layout"));
}


onDropHandler = (e) => {
  e.preventDefault();
  e.stopPropagation();
  return false;
}

onDragOver = (event) => {
  event.preventDefault();
  event.stopPropagation();
  return false;
}

SendBackgroundColor = (color) => {
  this.setState({send_background_color:color});
  this.setState({send_background_color_update:this.state.send_background_color_update === undefined?true:!this.state.send_background_color_update});
}

onDragEnter = (event) => {
  event.preventDefault();
  event.stopPropagation();
  return false;
}

ResetUpdatedDataset = () => {
  this.setState({updated_dataset:false});
}
//Router/Baserouter = determine component using adress bar
//custom layout = header + footer
//scroll to top = auto scroll to top when changing page

rejectAllCookies = () =>  {
    //console.log("reject");
  setCookie('rgpd_accept',"true",{expires:365});
  setCookie('rpgd_track',"false",{expires:365});
  this.setState({close_display:true});
}

acceptAllCookies = () => {
  //console.log("accept")
  setCookie('rgpd_accept',"true",{expires:365});
  setCookie('rpgd_track',"true",{expires:365});
  this.setState({close_display:true});
}

onClose = () => {
  //console.log("on close")
    this.setState({close_display:true});
}

onOk = () => {
 // console.log("on ok")
  setCookie('rgpd_accept',"true",{expires:365});
  setCookie('rpgd_track',this.state.allow_optionals.toString(),{expires:365});
  this.setState({close_display:true});
}

render() {
  return (
    <div>
            <MobileView>
            {
              (isTablet) ?
              <div>
                {
      this.state.maintenance === true? 
      <div>
      <div style={{position:'relative',margin:'auto',marginTop:'5%',textAlign:'center'}}>
      <img  alt="Logo" width='75' src="/images/refonte/BigLogoTransparentOmbre.png" style={{minWidth:'250px'}}></img>
      <h1 style={{fontSize:'19px',textAlign:'center',marginLeft:'5px',marginRight:'5px'}}> Morphonet is currently under maintenance. </h1>
                <br></br>
                <h1 style={{fontSize:'17px',textAlign:'center',marginLeft:'10px',marginRight:'10px'}}> Please come back later to access the MorphoNet project <span onClick={() => {this.setState({maintenance:false})}}>website</span> </h1>
                <br></br><br></br>

            </div>
      </div>
      :
    <div>
    <TutorialFilter clearTutorials={this.state.clear_tutorials} hideTutoSession={this.hideTutorialsForSession} flushTutorialList={this.FlushTutorialList} tutorialReady={this.state.user_settings_got} tutorialIsDiv={this.state.tutorial_list.length > 0?this.state.tutorial_list[0].is_div:undefined} tutorialSetting={this.state.tutorial_list.length > 0?this.state.tutorial_list[0].setting:""} tutorialNode={this.state.tutorial_list.length > 0?this.state.tutorial_list[0].node:undefined} tutorialX={this.state.tutorial_list.length > 0?this.state.tutorial_list[0].x:-1} tutorialY={this.state.tutorial_list.length > 0?this.state.tutorial_list[0].y:-1} tutorialText={this.state.tutorial_list.length > 0?this.state.tutorial_list[0].text:""} displayTutorial={this.DisplayTutorialFunc} closeTutorial={this.closeTutorialFunc} tutorialDisplayed={this.state.tutorial_displayed}></TutorialFilter>
    {
      this.state.tutorial_displayed && 
      <div style={{pointerEvents:'none',position:'absolute',zIndex:'25',width:'100%',height:'170%',backgroundColor:'#44D4FF',opacity:'75%'}}> </div>
    }
    <div  onClick={this.handleClickLayout}>
      <Router>
      <CustomLayout sendTracking={this.sendTracking} unityProgression={this.state.unity_loading_progress} ForceUnityKeyboardState={this.ForceKeyboardState} displayTutorial={this.DisplayTutorialFunc} tutorialReady={this.state.user_settings_got} showFromOutside={this.state.showFromMainMenu} clearCache={this.clearCache} datasetClicked={this.datasetButtonClicked} openUnityFromAway={this.openUnityFromOtherComponents} sendWindowedMode={this.windowedUnity}  unityWindowed={this.state.windowed} unityReset={this.askResetUnity} unityLoaded={this.state.unity_loaded} unityActive={this.state.unity_active} showUnity={this.changeUnityShowState} unityLoadFunc={this.receiveUnityProps} {...this.props}>
          {
             <UnityContainer receiveMaxTime={this.receiveMorphoMaxTime} receiveMinTime={this.receiveMorphoMinTime} clearMorphoPlotLineage={this.clearMorphoPlotLineage} storeMorphoPlotLineage={this.storeMorphoPlotLineage} sendTracking={this.sendTracking} onProgressUnity={this.onProgressUnity} liveMode={this.state.live_mode} keyboardState={this.state.keyboard_state} ResetUpdatedDataset={this.ResetUpdatedDataset} updatedDataset={this.state.updated_dataset} PropagateThis={this.propagateThis} HideCells={this.hideCells} ResetSelectionOnSelectedCells={this.resetSelectionOnSelectedCells} ApplySelectionMap={this.applySelectionMap} ApplySelection={this.applySelection} Uncolorize={this.uncolorize} Colorize={this.colorize} HideAllTimes={this.hideCellsAllTimes} ShowInLineage={this.showLineage} HideInLineage={this.hideLineage} clearAllLineage={this.clearAllLineage} lineageTimeCell={this.state.lineage_time} lineageIdCell={this.state.lineage_id} changeLineage={this.changeLineageStatus} sessionStages={this.state.session_stages} showFromOutside={this.state.showFromMainMenu} clearCache={this.state.clearCache} windowed={this.windowedUnity} sendWindowedMode={this.windowedUnity} windowed_mode={this.state.windowed} sendReset={this.state.unity_reset} resetUnityState={this.resetUnityResetState} unityLoadedFeedback={this.unityLoaded} active={this.state.unity_active} showUnity={this.changeUnityShowState} myCustomProps={this.state.unity_props}></UnityContainer>
          }
        <BaseRouter sendTracking={this.sendTracking} showUnity={this.changeUnityShowState} flushTutorialList={this.FlushTutorialList} tutorialReady={this.state.user_settings_got} tutorialSetting={this.state.tutorial_list.length > 0?this.state.tutorial_list[0].setting:""} tutorialRight={this.state.tutorial_list.length > 0?this.state.tutorial_list[0].posright:-1} tutorialX={this.state.tutorial_list.length > 0?this.state.tutorial_list[0].x:-1} tutorialY={this.state.tutorial_list.length > 0?this.state.tutorial_list[0].y:-1} tutorialText={this.state.tutorial_list.length > 0?this.state.tutorial_list[0].text:""} displayTutorial={this.DisplayTutorialFunc} closeTutorial={this.closeTutorialFunc} tutorialDisplayed={this.state.tutorial_displayed} receiveStage={this.receiveStage} onStageComputed={this.receiveStage} openUnityFromAway={this.openUnityFromOtherComponents} clearCache={this.clearCache} datasetClicked={this.state.dataset_button_clicked}  unityReset={this.askResetUnity}  unityLoaded={this.state.unity_loaded} unityLoadFuncMax={this.receiveUnityPropsMaximized} unityLoadFunc={this.receiveUnityProps}/>
      </CustomLayout>

      <ScrollToTop></ScrollToTop>
      </Router> 
      {
        this.state.display_lineage && 
        <NewWindow title={"Lineage"} name={"Lineage"} copyStyles={true} features={{titlebar:"no",location:'0',scrollbars:"no",width: window.innerWidth, height: window.innerHeight }}>
        <Lineage clearMorphoPlotLineage={this.clearMorphoPlotLineage} morphoPlotLineage={this.state.morphoPlotLineage !== undefined?this.state.morphoPlotLineage:undefined} sendTracking={this.sendTracking} style={{width:'100%'}} PropagateThisV={this.state.propagatethis_v} PropagateThisListCells={this.state.propagatethis_listcells+"|"+this.state.propagatethis_listcells_update} PropagateThisRGB={this.state.propagatethis_rgb} hidecellsV={this.state.hidecells_v} hidecellsListcells={this.state.hidecells_listcells} resetselection_listcells={this.state.resetselection_listcells} ApplySelectRGB={this.state.apply_select_rgb} ApplySelectListCells={this.state.apply_select_listcells} uncolorizeT={this.state.uncolorize_t} uncolorizeID={this.state.uncolorize_id} colorizeT={this.state.colorize_t} colorizeID={this.state.colorize_id} colorizeRGB={this.state.colorize_rgb} hideAllTimesCellsV={this.state.hide_all_t_v}  hideAllTimesCellsListCells={this.state.hide_all_t_listcells} showLineageT={this.state.show_lineage_t} showLineageID={this.state.show_lineage_ids} hideLineageT={this.state.hide_lineage_t} hideLineageID={this.state.hide_lineage_ids} clearLineage={this.state.clearLineage} showInUnity={this.showCellInUnity} width={window.innerWidth} height={window.innerHeight} min_time={this.state.morphoPlotMinTime !== -1?this.state.morphoPlotMinTime:this.state.unity_props['mintime']} max_time={this.state.morphoPlotMaxTime!=-1?this.state.morphoPlotMaxTime:this.state.unity_props['maxtime']} id_set={this.state.unity_props['id']}>

        </Lineage>
      </NewWindow>
      
      }

      {
        !this.hasValidatedCookies() && !this.state.close_display&&
        <div style={{outline:' 0.5px solid #44D4FF',position:'fixed',backgroundColor:'white',width:'100%',heigh:'30%',zIndex:'70',alignContent:'center',textAlign:'center',bottom:'0'}}>
          <div style={{height:'100%',width:'100%',marginTop:'3px',marginLeft:'3px',marginRight:'3px',marginBottom:'3px'}}>
                        
          <div style={{float:'right'}}><Button style={{float:'right',marginTop:'20px',marginRight:'15px',width:'150px',backgroundColor:'#44D4FF',borderColor:'#44D4FF'}} onClick={this.acceptAllCookies} type='primary'>Accept all</Button>
            <br></br><br></br><br></br>
            <Button style={{float:'right',marginBottom:'2px',marginTop:'5px',marginRight:'15px',width:'150px',borderColor:'lightgrey',backgroundColor:'white'}} onClick={this.rejectAllCookies} type='primary'><span style={{color:'grey'}}>Reject all</span></Button>
            {
              this.state.panel_display !== "optional" && 
              <Button style={{float:'right',marginBottom:'15px',marginTop:'5px',marginRight:'15px',width:'150px',backgroundColor:'#44D4FF',borderColor:'#44D4FF'}} onClick={() => {this.setState({panel_display:"optional"})}} type='primary'>See optionals</Button>
            }
            </div>
          {
            this.state.panel_display === "mandatory" &&
            <div style={{textAlign:'center',verticalAlign:'center'}}> 
              <span style={{fontSize:'16px',verticalAlign:'center'}}>These cookies are needed for the the site to work. <br></br> <br></br> They handle user session for a smooth navigation. <br></br> You cannot refuse these cookies.

              </span>
            </div>
          }

          {
            this.state.panel_display === "optional" &&
            <div style={{textAlign:'center',verticalAlign:'center'}}>
              <span style={{fontSize:'16px',verticalAlign:'center'}} >These cookies collect the way our users behave on our website. <br></br><br></br> They help understanding how we can ameliorate the website, and so the user experience. </span>
              <br></br>         <br></br>
              <span style={{marginTop:'5px'}}>Disable this cookie : </span><Switch
              checkedChildren={<CheckOutlined />}
              unCheckedChildren={<CloseOutlined />}
              checked = {this.state.allow_optionals}
              onChange = {() => {setCookie('rpgd_track',!(this.state.allow_optionals).toString(),{expires:365});this.setState({allow_optionals:!this.state.allow_optionals})}}
              style = {{marginLeft:'10px',marginBottom:'5px',marginTop:'10px',backgroundColor:'#44D4FF',borderColor:'#44D4FF'}}>
              
              </Switch>
              <Button style={{marginLeft:'150px',marginBottom:'5px',backgroundColor:'#44D4FF',borderColor:'#44D4FF'}} onClick={this.onOk} type='primary'>Accept this configuration</Button>
            </div>
          } 

          </div>
        </div>
      }
    </div>
    </div>
    }
              </div>
              : 
            <div style={{float:'left',margin:'auto',textAlign:'center'}}>
              {
                window.location === "" && 
                <img  alt="Logo" width='35' src="/images/refonte/BigLogoTransparentOmbre.png" style={{minWidth:'250px',marginTop:'15%'}}></img>
              }
              <Router>
              <CustomLayout  refreshDataset={this.refreshDataset} sendTracking={this.sendTracking} unityProgression={this.state.unity_loading_progress} ForceUnityKeyboardState={this.ForceKeyboardState} displayTutorial={this.DisplayTutorialFunc} tutorialReady={this.state.user_settings_got} showFromOutside={this.state.showFromMainMenu} clearCache={this.clearCache} datasetClicked={this.datasetButtonClicked} openUnityFromAway={this.openUnityFromOtherComponents} sendWindowedMode={this.windowedUnity}  unityWindowed={this.state.windowed} unityReset={this.askResetUnity} unityLoaded={this.state.unity_loaded} unityActive={this.state.unity_active} showUnity={this.changeUnityShowState} unityLoadFunc={this.receiveUnityProps} {...this.props}>
              {
                    <UnityContainer receiveMaxTime={this.receiveMorphoMaxTime} receiveMinTime={this.receiveMorphoMinTime} clearMorphoPlotLineage={this.clearMorphoPlotLineage} storeMorphoPlotLineage={this.storeMorphoPlotLineage} sendTracking={this.sendTracking} onProgressUnity={this.onProgressUnity} liveMode={this.state.live_mode} keyboardState={this.state.keyboard_state} ResetUpdatedDataset={this.ResetUpdatedDataset} updatedDataset={this.state.updated_dataset} PropagateThis={this.propagateThis} HideCells={this.hideCells} ResetSelectionOnSelectedCells={this.resetSelectionOnSelectedCells} ApplySelection={this.applySelection} Uncolorize={this.uncolorize} Colorize={this.colorize} HideAllTimes={this.hideCellsAllTimes} ShowInLineage={this.showLineage} HideInLineage={this.hideLineage} clearAllLineage={this.clearAllLineage} lineageTimeCell={this.state.lineage_time} lineageIdCell={this.state.lineage_id} changeLineage={this.changeLineageStatus} sessionStages={this.state.session_stages} showFromOutside={this.state.showFromMainMenu} clearCache={this.state.clearCache} windowed={this.windowedUnity} sendWindowedMode={this.windowedUnity} windowed_mode={this.state.windowed} sendReset={this.state.unity_reset} resetUnityState={this.resetUnityResetState} unityLoadedFeedback={this.unityLoaded} active={this.state.unity_active} showUnity={this.changeUnityShowState} myCustomProps={this.state.unity_props}></UnityContainer>
                  }
                <BaseRouter  updateClearAsk={this.updateClearAsk}  sendTracking={this.sendTracking} showUnity={this.changeUnityShowState} flushTutorialList={this.FlushTutorialList} tutorialReady={this.state.user_settings_got} tutorialSetting={this.state.tutorial_list.length > 0?this.state.tutorial_list[0].setting:""} tutorialRight={this.state.tutorial_list.length > 0?this.state.tutorial_list[0].posright:-1} tutorialX={this.state.tutorial_list.length > 0?this.state.tutorial_list[0].x:-1} tutorialY={this.state.tutorial_list.length > 0?this.state.tutorial_list[0].y:-1} tutorialText={this.state.tutorial_list.length > 0?this.state.tutorial_list[0].text:""} displayTutorial={this.DisplayTutorialFunc} closeTutorial={this.closeTutorialFunc} tutorialDisplayed={this.state.tutorial_displayed} receiveStage={this.receiveStage} onStageComputed={this.receiveStage} openUnityFromAway={this.openUnityFromOtherComponents} clearCache={this.clearCache} datasetClicked={this.state.dataset_button_clicked}  unityReset={this.askResetUnity}  unityLoaded={this.state.unity_loaded} unityLoadFuncMax={this.receiveUnityPropsMaximized} unityLoadFunc={this.receiveUnityProps}/>
                  </CustomLayout>
              </Router>             </div>      
            }
          </MobileView>

      <BrowserView>
   
   {
     (!isTablet) &&
     <div> 
    {
      this.state.maintenance === true? 
      <div>
      <div style={{position:'relative',margin:'auto',marginTop:'5%',textAlign:'center'}}>
      <img  alt="Logo" width='75' src="/images/refonte/BigLogoTransparentOmbre.png" style={{minWidth:'250px'}}></img>
      <h1 style={{fontSize:'19px',textAlign:'center',marginLeft:'5px',marginRight:'5px'}}> Morphonet is currently under maintenance. </h1>
                <br></br>
                <h1 style={{fontSize:'17px',textAlign:'center',marginLeft:'10px',marginRight:'10px'}}> Please come back later to access the MorphoNet project <span onClick={() => {this.setState({maintenance:false})}}>website</span> </h1>
                <br></br><br></br>

            </div>
      </div>
      :
    <div>
    <TutorialFilter clearTutorials={this.state.clear_tutorials} hideTutoSession={this.hideTutorialsForSession} flushTutorialList={this.FlushTutorialList} tutorialReady={this.state.user_settings_got} tutorialIsDiv={this.state.tutorial_list.length > 0?this.state.tutorial_list[0].is_div:undefined} tutorialSetting={this.state.tutorial_list.length > 0?this.state.tutorial_list[0].setting:""} tutorialNode={this.state.tutorial_list.length > 0?this.state.tutorial_list[0].node:undefined} tutorialX={this.state.tutorial_list.length > 0?this.state.tutorial_list[0].x:-1} tutorialY={this.state.tutorial_list.length > 0?this.state.tutorial_list[0].y:-1} tutorialText={this.state.tutorial_list.length > 0?this.state.tutorial_list[0].text:""} displayTutorial={this.DisplayTutorialFunc} closeTutorial={this.closeTutorialFunc} tutorialDisplayed={this.state.tutorial_displayed}></TutorialFilter>
    {
      this.state.tutorial_displayed && 
      <div style={{pointerEvents:'none',position:'absolute',zIndex:'25',width:'100%',height:'170%',backgroundColor:'#44D4FF',opacity:'75%'}}> </div>
    }
    <div  onClick={this.handleClickLayout}>
      <Router>
      <CustomLayout ask_clear={this.state.ask_clear} updateLastSearched={this.updateLastSearched} changeSearchedText={this.changeSearchedText} refreshDataset={this.refreshDataset} sendTracking={this.sendTracking} unityProgression={this.state.unity_loading_progress} ForceUnityKeyboardState={this.ForceKeyboardState} displayTutorial={this.DisplayTutorialFunc} tutorialReady={this.state.user_settings_got} showFromOutside={this.state.showFromMainMenu} clearCache={this.clearCache} datasetClicked={this.datasetButtonClicked} openUnityFromAway={this.openUnityFromOtherComponents} sendWindowedMode={this.windowedUnity}  unityWindowed={this.state.windowed} unityReset={this.askResetUnity} unityLoaded={this.state.unity_loaded} unityActive={this.state.unity_active} showUnity={this.changeUnityShowState} unityLoadFunc={this.receiveUnityProps} {...this.props}>
          {
             <UnityContainer pickCells={this.pickCells} cancelCells={this.cancelCells} updateSelectionColor={this.updateSelectionColor} SendBackgroundColor={this.SendBackgroundColor} clearCells={this.clearCells} SendHideCells={this.SendHideCells}  SendShowCells={this.SendShowCells} SendColors={this.SendColors} receiveColorInfo={this.receiveColorInfo} ApplySelectionMap={this.applySelectionMap} resetLineage={this.resetLineage} multipleSelection={this.multipleSelection} updateInfoDeployed={this.updateInfoDeployed} colorizeMultipleCells={this.colorizeMultipleCells} uncolorizeMultipleCells={this.uncolorizeMultipleCells} receiveInfoLineage={this.receiveInfo} focusCanvas={this.state.focus_canvas} receiveMaxTime={this.receiveMorphoMaxTime} receiveMinTime={this.receiveMorphoMinTime} clearMorphoPlotLineage={this.clearMorphoPlotLineage} storeMorphoPlotLineage={this.storeMorphoPlotLineage} sendTracking={this.sendTracking} onProgressUnity={this.onProgressUnity} liveMode={this.state.live_mode} keyboardState={this.state.keyboard_state} ResetUpdatedDataset={this.ResetUpdatedDataset} updatedDataset={this.state.updated_dataset} PropagateThis={this.propagateThis} HideCells={this.hideCells} ResetSelectionOnSelectedCells={this.resetSelectionOnSelectedCells} ApplySelection={this.applySelection} Uncolorize={this.uncolorize} Colorize={this.colorize} HideAllTimes={this.hideCellsAllTimes} ShowInLineage={this.showLineage} HideInLineage={this.hideLineage} clearAllLineage={this.clearAllLineage} lineageTimeCell={this.state.lineage_time+"/"+this.state.lineage_selection_reset} lineageIdCell={this.state.lineage_id} changeLineage={this.changeLineageStatus} sessionStages={this.state.session_stages} showFromOutside={this.state.showFromMainMenu} clearCache={this.state.clearCache} windowed={this.windowedUnity} sendWindowedMode={this.windowedUnity} windowed_mode={this.state.windowed} sendReset={this.state.unity_reset} resetUnityState={this.resetUnityResetState} unityLoadedFeedback={this.unityLoaded} active={this.state.unity_active} showUnity={this.changeUnityShowState} myCustomProps={this.state.unity_props}></UnityContainer>
          }
        <BaseRouter updateClearAsk={this.updateClearAsk} updateLastSearched={this.updateLastSearched} last_search_used={this.state.last_search_used} searched_text={this.state.searched_text} closeLineageFlag={this.state.lineage_close} refreshDataset={this.state.refresh_dataset} catchMessage={this.receiveMessage} sendTracking={this.sendTracking} showUnity={this.changeUnityShowState} flushTutorialList={this.FlushTutorialList} tutorialReady={this.state.user_settings_got} tutorialSetting={this.state.tutorial_list.length > 0?this.state.tutorial_list[0].setting:""} tutorialRight={this.state.tutorial_list.length > 0?this.state.tutorial_list[0].posright:-1} tutorialX={this.state.tutorial_list.length > 0?this.state.tutorial_list[0].x:-1} tutorialY={this.state.tutorial_list.length > 0?this.state.tutorial_list[0].y:-1} tutorialText={this.state.tutorial_list.length > 0?this.state.tutorial_list[0].text:""} displayTutorial={this.DisplayTutorialFunc} closeTutorial={this.closeTutorialFunc} tutorialDisplayed={this.state.tutorial_displayed} receiveStage={this.receiveStage} onStageComputed={this.receiveStage} openUnityFromAway={this.openUnityFromOtherComponents} clearCache={this.clearCache} datasetClicked={this.state.dataset_button_clicked}  unityReset={this.askResetUnity}  unityLoaded={this.state.unity_loaded} unityLoadFuncMax={this.receiveUnityPropsMaximized} unityLoadFunc={this.receiveUnityProps}/>
      </CustomLayout>
      <ScrollToTop></ScrollToTop>
      </Router> 
      {
        this.state.display_lineage && 
        <NewWindow onUnload={() => {this.askCloseLineage();}} title={"Lineage"} name={"Lineage"} copyStyles={true} features={{titlebar:"no",location:'0',scrollbars:"no",width: window.innerWidth, height: window.innerHeight }}>
        <Lineage user_id={this.state.connected_user_id} user_token={this.state.token} pickCellsParams={this.state.pickCellsParams === undefined?undefined:this.state.pickCellsParams+"|"+this.state.pickCellsParams_update} cancelCellsParams={this.state.cancelCellsParams === undefined?undefined:this.state.cancelCellsParams+"|"+this.state.cancelCellsParams_update} clearCellsParams={this.state.clearCellsParams===undefined?undefined:this.state.clearCellsParams+"|"+this.state.clearCellsParams_update} changeColorSelection={this.state.changeColorSelection===undefined?undefined:this.state.changeColorSelection+"|"+this.state.changeColorSelection_update} send_background_color={this.state.send_background_color===undefined?undefined:this.state.send_background_color+"|"+this.state.send_background_color_update} HideCellsList={this.state.hide_cell_list === undefined ?undefined:this.state.hide_cell_list+"|"+this.state.hide_cell_list_update} ShowCellsList={this.state.show_cell_list === undefined ?undefined:this.state.show_cell_list+"|"+this.state.show_cell_list_update} SendColors={this.state.send_color_list===undefined?undefined:this.state.send_color_list+"|"+this.state.send_color_update} receiveColorInfo={this.state.receiveColorInfo} idLineage={this.state.id_info_lineage} closeLineage={this.askCloseLineage} resetLineage={this.state.reset_lineage} multipleSelection={this.state.multipleselectioncells} deployInfoID={this.state.deployInfoID} lastInfoReceived={this.state.last_info_received} applySelectionLineage={this.state.apply_selection_lineage} clearMorphoPlotLineage={this.clearMorphoPlotLineage} morphoPlotLineage={this.state.morphoPlotLineage !== undefined?this.state.morphoPlotLineage:undefined} sendTracking={this.sendTracking} style={{width:'100%'}} PropagateThisV={this.state.propagatethis_v} PropagateThisListCells={this.state.propagatethis_listcells===undefined?undefined:this.state.propagatethis_listcells+"|"+this.state.propagatethis_listcells_update} PropagateThisRGB={this.state.propagatethis_rgb} hideCellsParams={this.state.hidecells_params===undefined?undefined:this.state.hidecells_params+"|"+this.state.hidecells_params_update} colorize_listcells={this.state.colorize_listcells} uncolorize_listcells={this.state.uncolorize_listcells} resetselection_listcells={this.state.resetselection_listcells} ApplySelectRGB={this.state.apply_select_rgb} ApplySelectListCells={this.state.apply_select_listcells} ApplySelectListCellsMap={this.state.apply_selectmap_listcells}  uncolorizeT={this.state.uncolorize_t} uncolorizeID={this.state.uncolorize_id} colorizeT={this.state.colorize_t} colorizeID={this.state.colorize_id} colorizeRGB={this.state.colorize_rgb} hideAllTimesCellsV={this.state.hide_all_t_v}  hideAllTimesCellsListCells={this.state.hide_all_t_listcells} showLineageT={this.state.show_lineage_t} showLineageID={this.state.show_lineage_ids} hideLineageT={this.state.hide_lineage_t} hideLineageID={this.state.hide_lineage_ids} clearLineage={this.state.clearLineage} showInUnity={this.showCellInUnity} width={window.innerWidth} height={window.innerHeight} min_time={this.state.morphoPlotMinTime !== -1?this.state.morphoPlotMinTime:this.state.unity_props['mintime']} max_time={this.state.morphoPlotMaxTime!=-1?this.state.morphoPlotMaxTime:this.state.unity_props['maxtime']} id_set={this.state.unity_props['id']}>

        </Lineage>
      </NewWindow>
      
      }

      {
        !this.hasValidatedCookies() && !this.state.close_display&&
        <div style={{outline:' 0.5px solid #44D4FF',position:'fixed',backgroundColor:'white',width:'100%',heigh:'30%',zIndex:'70',alignContent:'center',textAlign:'center',bottom:'0'}}>
          <div style={{height:'100%',width:'100%',marginTop:'3px',marginLeft:'3px',marginRight:'3px',marginBottom:'3px'}}>
                        
          <div style={{float:'right'}}><Button style={{float:'right',marginTop:'20px',marginRight:'15px',width:'150px',backgroundColor:'#44D4FF',borderColor:'#44D4FF'}} onClick={this.acceptAllCookies} type='primary'>Accept all</Button>
            <br></br><br></br><br></br>
            <Button style={{float:'right',marginBottom:'2px',marginTop:'5px',marginRight:'15px',width:'150px',borderColor:'lightgrey',backgroundColor:'white'}} onClick={this.rejectAllCookies} type='primary'><span style={{color:'grey'}}>Reject all</span></Button>
            {
              this.state.panel_display !== "optional" && 
              <Button style={{float:'right',marginBottom:'15px',marginTop:'5px',marginRight:'15px',width:'150px',backgroundColor:'#44D4FF',borderColor:'#44D4FF'}} onClick={() => {this.setState({panel_display:"optional"})}} type='primary'>See optionals</Button>
            }
            </div>
          {
            this.state.panel_display === "mandatory" &&
            <div style={{textAlign:'center',verticalAlign:'center'}}> 
              <span style={{fontSize:'16px',verticalAlign:'center'}}>These cookies are needed for the the site to work. <br></br> <br></br> They handle user session for a smooth navigation. <br></br> You cannot refuse these cookies.

              </span>
            </div>
          }

          {
            this.state.panel_display === "optional" &&
            <div style={{textAlign:'center',verticalAlign:'center'}}>
              <span style={{fontSize:'16px',verticalAlign:'center'}} >These cookies collect the way our users behave on our website. <br></br><br></br> They help understanding how we can ameliorate the website, and so the user experience. </span>
              <br></br>         <br></br>
              <span style={{marginTop:'5px'}}>Disable this cookie : </span><Switch
              checkedChildren={<CheckOutlined />}
              unCheckedChildren={<CloseOutlined />}
              checked = {this.state.allow_optionals}
              onChange = {() => {setCookie('rpgd_track',!(this.state.allow_optionals).toString(),{expires:365});this.setState({allow_optionals:!this.state.allow_optionals})}}
              style = {{marginLeft:'10px',marginBottom:'5px',marginTop:'10px',backgroundColor:'#44D4FF',borderColor:'#44D4FF'}}>
              
              </Switch>
              <Button style={{marginLeft:'150px',marginBottom:'5px',backgroundColor:'#44D4FF',borderColor:'#44D4FF'}} onClick={this.onOk} type='primary'>Accept this configuration</Button>
            </div>
          } 

          </div>
        </div>
      }
    </div>
    </div>
    }
   </div> 
  }
    </BrowserView>
    </div>
  );
}
}

//data of global app in the components
const mapStateToProps = state => {
  return {
      isAuthenticated: state.token !== null,

  }
}

//check autosignup
const mapDispatchToProps = dispatch => {
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState())
  }
}

export default connect(mapStateToProps,mapDispatchToProps) (App);
